import { useContext } from "react"
import { Redirect } from "react-router-dom"
import { AuthContext } from "context/context/AuthContext"
import { ResourceRoleEnum } from "enums/ResourceRoleEnum"

/**
 * Componente que maneja las redirecciones basadas en el rol del usuario
 * Si el usuario tiene rol "webapp-contractor-source", lo redirige a contractor/dashboard
 * De lo contrario, lo redirige al dashboard por defecto
 */
const RedirectWrapper = ({ defaultPath = "/dashboard" }: { defaultPath?: string }) => {
  const { state: { user } } = useContext(AuthContext)

  // Si el usuario tiene rol de contractor-source, redirigir a contractor/dashboard
  if (user?.role === ResourceRoleEnum["webapp-contractor-source"]) {
    return <Redirect to="/contractor/dashboard" />
  }

  // Para otros roles, usar la ruta por defecto
  return <Redirect to={defaultPath} />
}

export default RedirectWrapper
